import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import PageHeader from "../PageHeader";
import NotificationsPanel from "../../NotificationsPanel";
import Dashboard from "@/pages/admin/Dashboard";
import Organizations from "@/pages/admin/Organizations/Organizations";
import Forms from "@/pages/admin/Forms/Forms";
import OrganizationDetails from "@/pages/admin/Organizations/OrganizationDetails";
import FormDetails from "../../../pages/admin/Forms/FormDetails";
import AddQuestion from "../../../pages/admin/Forms/AddQuestion";
import QuestionDetails from "../../../pages/admin/Forms/QuestionDetails";
import Campaigns from "../../Campaigns/Campaigns";
import CampaignDetails from "../../Campaigns/CampaignDetails";
import Interpreter from "../../../pages/admin/Interpreter/Interpreter";
import PanelUser from "../../../pages/admin/PanelUser/PanelUser";
import ManageAssignments from "../../../pages/admin/Interpreter/ManageAssignments";
// import SurveyFlow from './SurveyFlow';
import SurveyIntro from "../../../pages/FormSubmissions/SurveyIntro";
import ViewQuestionPage from "../../../pages/FormSubmissions/ViewQuestionPage";
import SurveyFlow from "./SurveyFlow";
import ArchivedForms from "../../../pages/admin/Forms/ArchivedForms";
import Enquiries from "../../../pages/admin/Enquiries/Enquiries";
import VideoCatalog from "../../../pages/admin/VideoCatalog/VideoCatalog";
import Template from "../../../pages/admin/Template/Template";
import CreateQuestionTemplate from "../../../pages/admin/Forms/CreateQuestionTemplate";
import TemplateFormDetails from "../../../pages/admin/Template/TemplateFormDetails";
import ThankYou from "../../../pages/FormSubmissions/ThankYou";
// import ViewQuestionPage from '../../../pages/FormSubmissions/ViewQuestionPage';

const { Content } = Layout;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [notificationsVisible, setNotificationsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width <= 768;
      setIsMobile(mobile);

      // Only show toggle on mobile
      setShowToggle(mobile);

      // Auto-collapse on mobile, but maintain user preference on desktop
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = () => {
    if (isMobile) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        notificationsVisible={notificationsVisible}
        setNotificationsVisible={setNotificationsVisible}
        isMobile={isMobile}
        handleToggle={handleToggle}
      />
      <NotificationsPanel
        visible={notificationsVisible}
        onClose={() => setNotificationsVisible(false)}
      />
      <Layout>
        <PageHeader
          collapsed={collapsed}
          setCollapsed={handleToggle}
          isMobile={isMobile}
          showToggle={showToggle}
        />
        <Content className="px-5 pb-5 md:p-6 pt-0 bg-white h-[80vh] overflow-y-scroll hide-scrollbar">
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/admin/dashboard" replace />}
            />
            <Route
              path="dashboard"
              element={
                <Dashboard collapsed={collapsed} handleToggle={handleToggle} />
              }
            />
            <Route path="organisations" element={<Organizations />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="campaigns/:id" element={<CampaignDetails />} />
            <Route path="forms" element={<Forms />} />
            <Route path="forms/archived" element={<ArchivedForms />} />
            <Route path="enquiries" element={<Enquiries />} />
            <Route path="video-catalog" element={<VideoCatalog />} />
            <Route path="templates" element={<Template />} />
            <Route
              path="question-template"
              element={<CreateQuestionTemplate />}
            />

            {/* admin/forms/archived */}

            <Route path="interpreter" element={<Interpreter />} />
            <Route path="panel-user" element={<PanelUser />} />
            <Route
              path="interpreter/assignments"
              element={<ManageAssignments />}
            />
            <Route path="organisations/:id" element={<OrganizationDetails />} />
            <Route path="forms/:id" element={<FormDetails />} />
            {/* <Route path="forms/:id" element={<TemplateFormDetails />} /> */}

            <Route path="template-form/:id" element={<TemplateFormDetails />} />

            {/* <Route path="template-form/:formId/questions/add" element={<CreateQuestionTemplate mode="add" />} /> */}
            <Route
              path="template-form/:formId/questions/edit/:questionId"
              element={<CreateQuestionTemplate mode="edit" />}
            />
            <Route
              path="template-form/:formId/questions/add"
              element={<CreateQuestionTemplate mode="add" />}
            />

            <Route
              path="forms/:formId/questions/add"
              element={<AddQuestion mode="add" />}
            />
            <Route
              path="forms/:formId/questions/edit/:questionId"
              element={<AddQuestion mode="edit" />}
            />
            <Route
              path="forms/:formId/questions/details/:questionId"
              element={<QuestionDetails />}
            />
            <Route path=":formId" element={<SurveyFlow />} />
            {/* <Route path="intro/:formId" element={<SurveyIntro />} />     */}
            <Route path="question/thank-you" element={<ThankYou />} />
            <Route path="question/thank-you/:formId" element={<ThankYou />} />
            <Route
              path="question/thank-you/:formId/:questionNumber"
              element={<ThankYou />}
            />
            <Route
              path="question/:formId/:questionNumber"
              element={<ViewQuestionPage />}
            />
            <Route
              path="*"
              element={<Navigate to="/admin/dashboard" replace />}
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
